import { createApi } from '@reduxjs/toolkit/query/react';

import { apiGocardlessClientSignups } from '~constants/api';

import { rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';
import {
  BulkSignupCountResponse,
  BulkSignupFilters,
  BulkSignupResponse,
} from '~direct-debits/models';

export const signupsApi = createApi({
  reducerPath: 'directDebitsSignupsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiGocardlessClientSignups }),
  tagTypes: ['signups'],
  endpoints: (builder) => ({
    // API expects mandate_states[]=... (Express qs default; Axios serialises arrays this way)
    getCount: builder.query<BulkSignupCountResponse, BulkSignupFilters & { detailed?: boolean }>({
      query: (filters) => ({
        url: '/count',
        method: 'GET',
        params: filters,
      }),
      transformResponse: (payload) => unwrap<BulkSignupCountResponse>(payload),
    }),
    bulkSend: builder.mutation<BulkSignupResponse, BulkSignupFilters & { subject: string; body: string }>({
      query: (body) => ({
        url: '/bulk-send',
        method: 'POST',
        body,
      }),
      transformResponse: (payload) => unwrap<BulkSignupResponse>(payload),
    }),
  }),
});

export const { useGetCountQuery, useBulkSendMutation } = signupsApi;
